import { IContract } from "@/core/model/sys/IContract";
import BaseService from "../base/BaseService";
import IParamServices from "../IParamServices";
import { IAgreement } from "@/core/model/sys/IAgreement";
import { IAgreementPeriod } from "@/core/model/sys/IAgreementPeriod";
import { IServiceResponse } from "@/core/model/rest/IServiceResponse";
import { IPagedParameters, IPagedResult } from "@/core/model/sys/IPagedParameters";
import { IInvoicePayment } from "@/core/model/sys/IInvoicePayment";

export interface IAgreementBalance 
{
  TotalPagos: number,
  Pagos:number,
  Saldo:number;
}
export default class AgreementService extends BaseService
{
  constructor(param: IParamServices)
  {
    super(param);
  }
  public newAgreement(contract:IContract):IAgreement
  {
    const hoy = new Date();
    return {
    Gid:this.NewId,
    Code:'',
    Contract:contract,
    AgreementPeriodId:0,
    AgreementPeriod:null,
    StartDate:hoy,
    EndDate:null,
    Total:0,
    AmountPayment:0,
    Comments:'',
    ModifiedByEmployee:null,
    Invoices:null,
    Active:true,
    IsNew:true,
    Error:'',
    ErrorSave:false,
    Balance:null
    };
  }
  public async AgreementPeriod():Promise<IAgreementPeriod[]>
  {
    const data = Array<IAgreementPeriod>();
    const response:IServiceResponse = await this.Get('IndexAgreement/AgreementPeriod',null,null,null,true,false,null);  
    if(response.Response)
    {
      for (const element of response.Response)
      {
        data.push({...element});  
      }
    }    
    return data;
  } 
  public CalculateEndDate(periodo:IAgreementPeriod|null,total:number,amount:number,start:Date):Date
  {
    if(!periodo || !total || !amount) return start;
    /*    
  1	M	Mensual
  2	S	Semanal
  3	Q	Quicenal
  4	B	Bimestral
    */
    let months = 0;
    let endDate = new Date();
    const totalPayments = Math.ceil(total/amount);
    
    switch(periodo.AgreementPeriodId)
    {
      case 1:
        endDate = new Date(new Date(start).setMonth(start.getMonth() + (totalPayments)));
        break;
      case 2:
        months = Math.ceil(totalPayments/4);//4 semanas en 1 mes
        endDate = new Date(new Date(start).setMonth(start.getMonth() + (months)));
        break;
      case 3:
        months = Math.ceil(totalPayments/2);//2 quincenas en 1 mes
        endDate = new Date(new Date(start).setMonth(start.getMonth() + (months)));
        break;
      case 4:
        months = Math.ceil(totalPayments*2);//cada 2 meses
        endDate = new Date(new Date(start).setMonth(start.getMonth() + (months)));
        break;
      default:
        endDate = start;
        break
    }        
    return endDate;
  }
  
  public async SaveAgreement(agreementData:IAgreement) : Promise<IAgreement>
  {        
    let response:IServiceResponse|null = null;
    const agreement = {...agreementData};     
    response = await this.Post('IndexAgreement/SaveAgreement',agreement,null,null,null,true,false,null);
    if(response && response.Response)
    {
      if(response.Response.Error)
      {
        agreement.ErrorSave = true;
        agreement.Error = response.Response.Response;  
      }
      else
      {
        agreement.Code = response.Response.AgreementDto? response.Response.AgreementDto.Code:'';
        agreement.ErrorSave = false;
        agreement.Error = ''; 
      }
    }
    return agreement;
  }
  public async QuickSearchAgreementPaged(paged:IPagedParameters,contract:IContract,filter:string):Promise<IPagedResult<IAgreement>>
  {    
    const result: IPagedResult<IAgreement> = {
      Paged:null,
      Result:[]
    }  
    const filters = 
    {
      Page: paged.Page,     
      SecondaryId: contract.Gid, 
      Search: filter
    }        
    const response:IServiceResponse = await this.Post('IndexAgreement/QuickSearchAgreementPaged',filters,null,null,null,true,false,null); 
    if(response)
    {
      result.Paged = response.Paged;
      result.Result = response.Response? response.Response:[];
      for (const agreement of result.Result)
      {
        agreement.Balance = this.AgreementBalance(agreement);
      }
    }
    return result;
  }
  public async GetAgreement(gid:any): Promise<IAgreement|null>
  {
    let response:IServiceResponse|null = null;
    response = await this.Get('IndexAgreement/GetAgreement/' + gid,null,null,null,true,false,null);
    if(response && response.Response)
    {
      response.Response.Balance = this.AgreementBalance(response.Response);
      return response.Response;
    }
    return null;
  }
  public AgreementBalance = (agreement:IAgreement):IAgreementBalance => 
  {    
      let total = 0;
      let totalP = 0;
      if(agreement && agreement.Invoices && agreement.Invoices.length > 0)
      {
      for (const invoice of agreement.Invoices) 
      {
          if(invoice.Payments && invoice.Payments.length>0)
          {
              const apply = invoice.Payments.filter((x:IInvoicePayment) => x.IsApproved);        
              apply.forEach((x:IInvoicePayment) => { total = total + x.Amount;}); 
              totalP = apply.length;           
          }     
      }
      return {
          TotalPagos:total,
          Pagos:totalP,
          Saldo:agreement.Total - total
      };
      }
      else
      return {
          TotalPagos:0,
          Pagos:0,
          Saldo:agreement.Total
      };
  };
  public AgreementBalance2 = (agreement:IAgreement,payments:IInvoicePayment[]):IAgreementBalance => 
    {    
        let total = 0;
        let totalP = 0;
        if(agreement && payments && payments.length > 0)
        {
          const apply = payments.filter((x:IInvoicePayment) => x.IsApproved);        
                  apply.forEach((x:IInvoicePayment) => { total = total + x.Amount;}); 
                  totalP = apply.length;  
          return {
              TotalPagos:total,
              Pagos:totalP,
              Saldo:agreement.Total - total
          };
        }
        else
        return {
            TotalPagos:0,
            Pagos:0,
            Saldo:agreement.Total
        };
    };
}